import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";

type Props = {
  open: boolean;
  onClose: () => void;
  onDelete: () => void;
};

export const ConfirmDeleteCompanyDialog = ({
  open,
  onClose,
  onDelete,
}: Props) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>会社を削除しますか？</DialogTitle>
      <DialogContent>
        <DialogContentText>
          論理削除されるため物理的なデータは残りますが、画面上から元に戻すことは出来ません。
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" color="error" onClick={onDelete}>
          削除
        </Button>
      </DialogActions>
    </Dialog>
  );
};
